module.exports = __webpack_public_path__ + "static/media/gh-map-education-tc.dfb60ea3.png";